/* global I18n */
import moment from 'moment'

export function initLocale (locale) {
  if (locale) {
    if (typeof window === 'undefined' ? I18n : window.I18n) {
      I18n.locale = locale
    }
    if (moment) {
      moment.locale(locale === 'en' ? 'en-gb' : locale)
      if (locale === 'en') {
        moment.updateLocale('en', { longDateFormat: { LLLL: 'dddd, Do [of] MMMM, HH:mm' } })
      } else if (locale === 'ar') {
        moment.defineLocale('ar', {
          parentLocale: 'ar',
          preparse: function (string) {
            return string
          },
          postformat: function (string) {
            return string
          }
        })
      }
    }
  }
}
